import { Portal } from '@mantine/core';
import { useUnit } from 'effector-react';
import { CSSProperties } from 'react';
import { interactiveElementModel } from '../../model';
import cls from './interactive-element-ball.module.scss';

export const InteractiveElementBall = () => {
	const { visible, size, x, y } = useUnit(interactiveElementModel.$ball);

	return (
		<Portal>
			<div
				style={{
					...({
						'--ball-size': `${size}px`,
						'--ball-x': `${x}px`,
						'--ball-y': `${y}px`,
					} as CSSProperties),
				}}
				className={cls.interactiveElementBall}
				data-visible={visible || undefined}
			/>
		</Portal>
	);
};
